var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "map-controls" }, [
      _c(
        "div",
        [
          _vm._v(" 是否开启 ："),
          _c("el-switch", {
            attrs: {
              disabled: _vm.checkPermi([
                "admin:merchant:reservation:to:home:edit",
              ])
                ? false
                : true,
              "active-value": true,
              "inactive-value": false,
              "active-text": "开启",
              "inactive-text": "关闭",
            },
            on: { change: _vm.handleSave },
            model: {
              value: _vm.form.serviceAreaSwitch,
              callback: function ($$v) {
                _vm.$set(_vm.form, "serviceAreaSwitch", $$v)
              },
              expression: "form.serviceAreaSwitch",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "control-buttons" },
        [
          _vm.checkPermi(["admin:merchant:reservation:to:home:edit"])
            ? _c(
                "el-button-group",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editorMode === "edit",
                          expression: "editorMode === 'edit'",
                        },
                      ],
                      attrs: { icon: "el-icon-delete" },
                      on: { click: _vm.deleteSelectedPolygon },
                    },
                    [_vm._v(" 删除 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-edit-outline" },
                      on: {
                        click: function ($event) {
                          return _vm.setEditorMode("edit")
                        },
                      },
                    },
                    [_vm._v(" 编辑 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-edit" },
                      on: {
                        click: function ($event) {
                          return _vm.setEditorMode("draw")
                        },
                      },
                    },
                    [_vm._v(" 新增 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-check" },
                      on: { click: _vm.handleSave },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
    _c("div", { attrs: { id: "container" } }),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "font14 mt20 from-tips line-height-15" }, [
      _c("div", [
        _c("p", [
          _vm._v(
            "【绘制模式】鼠标左键点击及移动即可绘制图形，双击结束绘制。可以绘制多个区域"
          ),
        ]),
        _c("p", [
          _vm._v(
            "【编辑模式】可以拖拽顶点调整多边形形状，点击边线添加新顶点，地图会自动定位到绘制区域中心"
          ),
        ]),
        _c("p", [
          _vm._v(
            '【删除功能】编辑模式下选中多边形后点击"删除选中"删除指定区域'
          ),
        ]),
        _c("p", [
          _vm._v(
            "【多区域支持】支持绘制和编辑多个独立的服务区域，每个区域可以单独编辑和删除"
          ),
        ]),
        _c("p", [
          _vm._v("【其他操作】ESC键中断绘制，Ctrl+Z撤销操作，右键撤销绘制点"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }